export const rejectsSpecialCharacters = new RegExp(/^[a-zA-Z0-9\sñÑ]*$/);
export const acceptValidAmountOnly = new RegExp(/^[0-9]*\.{0,1}[0-9]*$/);
export const zipCode = new RegExp(/^[0-9]{0,4}$/);
export const bankAccountNumber = new RegExp(/^[0-9]{0,32}$/);
export const url = new RegExp(
  /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g
);
